import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React, { useCallback } from "react";
import { Refresh } from "@mui/icons-material";
import { atom } from "jotai";
import { appetizeSessionStore } from "@/atoms";

const ForceUpdateDialog = ({ open }: { open: boolean }) => {
  const handleClose = useCallback(({ event, reason }) => {
    return;
  }, []);

  const handleRefresh = useCallback(() => {
    location.reload();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"New Update Available"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          A new version of this web application has been released. Please
          refresh the page to continue using the latest version.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          startIcon={<Refresh />}
          onClick={handleRefresh}
          variant={"contained"}
        >
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const forceUpdateManualConditionsStateAtom = atom<{
  unsavedTest: boolean;
}>({
  unsavedTest: false,
});

const forceUpdateConditionsStateAtom = atom((get) => {
  const session = appetizeSessionStore.state;
  const forceUpdateManualConditionsState = get(
    forceUpdateManualConditionsStateAtom
  );

  return {
    activeSession: session.getData() != null,
    ...forceUpdateManualConditionsState,
  };
});

export { forceUpdateManualConditionsStateAtom, forceUpdateConditionsStateAtom };

export default ForceUpdateDialog;
